import { render, staticRenderFns } from "./PortineriaMenuView.vue?vue&type=template&id=27ecf944&"
import script from "./PortineriaMenuView.vue?vue&type=script&lang=ts&"
export * from "./PortineriaMenuView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports